<template>
  <div>
    <div class="banner">
			<div class="title">
				<div class="backColor"></div>
				<div class="overlay">卓越服务 · 塑造品牌价值</div>
			</div>
		</div>

		<section class="box">
			<div class="mobile_title">用我们的服务，创造您的价值</div>
			<div class="content">佐云科技核心管理团队均来自于行业领先的软件及网络科技公司，积累了丰富的大型网络架构设计及研发管理经验。公司技术骨干团队潜心技术积累及产品创新，设计研发了多项行业领先的前沿网络技术及能力。公司业务骨干团队具备广泛的行业解决方案能力积累，具备丰富的行业项目售前、交付及运维经验。</div>
		</section>

		<section class="box" style="margin: 50px 0 30px">
			<div class="mobile_title">服务支持</div>
			<div class="flex-wrap">
				<div class="server" v-for="(item,index) in serverList" :key='index'>
					<el-image :src="item.src" class="img"></el-image>
					<div class="name">{{item.name}}</div>
					<div class="content">{{item.content}}</div>
					<div class="content" style="margin-top: -5px">{{item.content1}}</div>
				</div>
			</div>
		</section>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				serverList: [
					{ src: require('@/assets/index/ser1.png'),name: '尊享服务',content: '7*24*365',content1: '运维保障响应' },
					{ src: require('@/assets/index/ser2.png'),name: 'SLA服务保障',content: '骨干网99.99%',content1: '高可用性' },
					{ src: require('@/assets/index/ser3.png'),name: '备件升级',content: '合同服务期间',content1: '免费升级备件' },
					{ src: require('@/assets/index/ser4.png'),name: '远程支持',content: '通过远程工具',content1: '实时远程支持协助' },
				],
			}
		},
		mounted() { },
		methods: { },
	}
</script>

<style scoped lang="scss">
/* banner图 */
.banner {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../image/banner/serve.jpg") no-repeat;
  background-size: cover;// 全覆盖
	background-position: center; //指定元素背景图片的位置  
	.title{
		position: relative;
		.backColor {
			width: 210px;
			height: 25px;
      line-height: 25px;
			background-color: rgba(248, 242, 242, 0.2);
			backdrop-filter: blur(5px); /* 调整模糊程度 */
		}
		.overlay {
      position: absolute;
			top: 0px;
			left: 5px;
			color: white;
      height: 25px;
      line-height: 25px;
      font-size: 16px;
      letter-spacing: 2px;
		}
	}
}
.content {
	color: #4B4B4B;
	line-height: 25px;
	padding: 0 15px;
	text-align: justify;
}
.server {
	width: calc((100% - 6px) / 2);
	height: 180px;
	background: linear-gradient(to bottom, #E5F3FF, white);
	border-radius: 10px;
	text-align: center;
	// box-sizing: border-box;
	.img {
		height: 40px;
		margin: 20px 0;
	}
	.name {
		font-size: 18px;
		color: #2D79E4;
		font-weight: 600;
	}
	.content {
		margin-top: 5px;
		font-size: 14px;
		color: grey;
		text-align: center;
	}
}
</style>